import CustomerList from "./manageUsers/userList";
import CustomerTopbar from "./manageUsers/topbar";
import manageproducts from "./productManagement/manageProducts";
import ManageInventory from "./productManagement/manageInventory";
import addProduct from "./productManagement/addProduct";
import editProduct from "./productManagement/editProduct";
import ViewProduct from "./productManagement/viewProduct";
import OrderManagement from "./orderManagement/order";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddProduct from "./DiscountAndCoupon/add";
import viewDiscount from "./DiscountAndCoupon/view";
import ViewOrder from "./orderManagement/view";
import ViewOrderManagement from "./orderManagement/view";

/* eslint-disable import/no-anonymous-default-export */
export default {
  CustomerTopbar,
  CustomerList,
  manageproducts,
  ManageInventory,
  addProduct,
  editProduct,
  ViewProduct,
  OrderManagement,
  DiscountCoupon,
  AddProduct,
  viewDiscount,
  ViewOrder,
  ViewOrderManagement

};
